/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-dupe-keys */
import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { useTheme } from '@mui/material/styles'
import { TextField, Grid, Box, CardHeader, List, ListItem, ListItemText } from '@mui/material';
import SendIcon from '@material-ui/icons/Send';
import { Button } from '@mui/material';
import { useSelector } from 'react-redux';

import { sendSMS } from '../../services'

export default function Chat({socket}) {
    const bottomRef = useRef(null);
    const theme = useTheme()

    const { to } = useSelector(state => state.number)

    const [value, setValue] = useState("")
    const [chat, setChat] = useState([])

    const { messages, name, number } = chat

    useEffect(()=> {
        // Once loaded sends 'toNumber' to the socket waiting for onmessage response
        if (socket.readyState === 1) {
            socket.send(to)
        }
    }, [to])

    socket.onmessage = (e) => {
        setChat(JSON.parse(e.data))
    }

    useEffect(() => {
        // 👇️ scroll to bottom every time messages change
        bottomRef.current?.scrollIntoView({behavior: 'smooth'});
    }, [(messages ? messages[0]?.body : false)]);

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSubmit();
        }
    }

    const handleSubmit = () => {
        sendSMS(
            number,
            value
        )
        setValue('')
    }

    return (
        <Box
            key="number"
            container
            boxShadow={3}
            style={{
                width: '60vw',
                position: 'absolute',
                right: 5,
                top: 80,
                backgroundColor: '#172067',
                overflowY: 'auto'
            }}>
            <Grid container sx={{height: '85vh'}}>

                <CardHeader
                    title={(to && messages) ? name : "No number selected"}
                    subheader={(to && messages) ? number : "Select a message or create a contact"}
                    sx={{
                        position: '-webkit-sticky',
                        position: 'sticky',
                        backgroundColor: 'rgba(16, 23, 79,0.8)',
                        top: 0,
                        zIndex: 5,
                        width: '100%'
                    }}
                />

                <List style={{
                    overflowY: 'auto',
                    width: '100%',
                    height: '85vh',
                }}>

                    {number && messages &&
                        <>
                            {messages?.map((element, index) => {
                                return (
                                    <ListItem key={index}>
                                        <Grid container>
                                            <Grid item xs={12}>
                                                <ListItemText align="center" secondary={moment(element.createdAt).format("h:mm a MMM Do")}></ListItemText>
                                            </Grid>
                                            <Grid item xs={12}>
                                                {
                                                    element.from === number ?
                                                        <ListItemText
                                                            align="left"
                                                            primaryTypographyProps={{ style: { 
                                                                color: '#232b2b', 
                                                                width: '25vw',
                                                                padding: '10px 10px',
                                                                borderRadius: '7px',
                                                                background: '#D3D3D3'
                                                            } }}
                                                            primary={
                                                                `${element.body}`
                                                            }></ListItemText> :
                                                        <ListItemText
                                                            align="right"
                                                            primaryTypographyProps={{ style: { 
                                                                color: '#e5e5e5', 
                                                                textAlign: 'left',
                                                                width: '25vw',
                                                                padding: '10px 10px',
                                                                borderRadius: '7px',
                                                                background: theme.palette.primary.main
                                                            } }}
                                                            primary={
                                                                `${element.body}`
                                                            }></ListItemText>
                                                }
                                            </Grid>
                                            <div ref={bottomRef} />
                                        </Grid>
                                    </ListItem>
                                )
                            })}
                        </>
                    }

                </List>

                {to && messages &&
                    <Grid container sx={{ padding: '1px' }}>
                        <Grid item xs={10}>
                            <TextField
                                onKeyDown={onKeyDown}
                                value={value}
                                onChange={e => setValue(e.target.value)}
                                variant="outlined"
                                label="Message"
                                fullWidth
                                inputStyle={{ color: 'white' }}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <Button
                                onClick={handleSubmit}
                                sx={{ padding: '15px' }}
                                size='large'
                                variant='outlined'
                                color="secondary">
                                <SendIcon />
                            </Button>
                        </Grid>
                    </Grid>
                }
            </Grid>
        </Box>
    );
}